import { render, staticRenderFns } from "./MobileCategoryCard.vue?vue&type=template&id=ba8e12f0&"
import script from "./MobileCategoryCard.vue?vue&type=script&lang=js&"
export * from "./MobileCategoryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports